/* @ngInject */
function ImageCarouselController ($scope, $timeout, UdsModalService, $q, ToastService, $translate, SocialMediaService, ArtsService) {
  const getAddMaterialsModalController = () => $q.when(import('../add-materials-modal/add-materials-modal.controller'))

  let scrollContainer = null
  let autoScrollInterval = null
  let isDragging = false
  let sortableInstance = null

  $scope.selectedIndex = 0

  const api = {
    getAddMaterialsModalController,
    _onMaterialsToAttach,
    _handleMultiPageMaterial
  }

  this.getApi = () => api

  activate()

  function activate () {
    _addMouseListener()
    _initializeSortable()
  }

  function _initializeSortable () {
    const getSortable = () => import('sortablejs')

    $timeout(() => {
      const sortableElement = document.querySelector('.sortable-images')
      scrollContainer = document.querySelector('.image-carousel-content')

      if (sortableElement && scrollContainer) {
        getSortable().then(({ Sortable }) => {
          $timeout(() => {
            sortableInstance = Sortable.create(sortableElement, {
              animation: 150,
              ghostClass: 'sortable-ghost',
              chosenClass: 'sortable-chosen',
              dragClass: 'sortable-drag',
              onStart: (evt) => {
                isDragging = true
                _startAutoScroll()
              },
              onEnd: (evt) => {
                isDragging = false
                _stopAutoScroll()
                _handleImageReorder(evt)
              }
            })
          }, 100)
        })
      }
    }, 100)
  }

  function _reinitializeSortable () {
    if (sortableInstance) {
      sortableInstance.destroy()
      sortableInstance = null
    }

    $timeout(() => {
      _initializeSortable()
    }, 50)
  }

  function _handleImageReorder (evt) {
    const { oldIndex, newIndex } = evt

    if (oldIndex !== newIndex && $scope.materials) {
      const movedImage = $scope.materials.splice(oldIndex, 1)[0]
      $scope.materials.splice(newIndex, 0, movedImage)

      if ($scope.selectedIndex === oldIndex) {
        $scope.selectedIndex = newIndex
      } else if ($scope.selectedIndex > oldIndex && $scope.selectedIndex <= newIndex) {
        $scope.selectedIndex--
      } else if ($scope.selectedIndex < oldIndex && $scope.selectedIndex >= newIndex) {
        $scope.selectedIndex++
      }

      $scope.$emit('imageCarousel:reorder', {
        oldIndex,
        newIndex,
        materials: $scope.materials,
        selectedIndex: $scope.selectedIndex
      })
    }
  }

  function _startAutoScroll () {
    if (!autoScrollInterval) {
      autoScrollInterval = setInterval(() => {
        if (isDragging && scrollContainer) {
          _checkAutoScroll()
        } else if (!isDragging) {
          _stopAutoScroll()
        }
      }, 16)
    }
  }

  function _stopAutoScroll () {
    if (autoScrollInterval) {
      clearInterval(autoScrollInterval)
      autoScrollInterval = null
    }
  }

  function _checkAutoScroll () {
    if (!scrollContainer || !isDragging) return

    const containerRect = scrollContainer.getBoundingClientRect()
    const scrollThreshold = 80
    const scrollSpeed = 8

    const canScrollLeft = scrollContainer.scrollLeft > 0
    const canScrollRight = scrollContainer.scrollLeft < (scrollContainer.scrollWidth - scrollContainer.clientWidth)

    if (mouseX < containerRect.left + scrollThreshold && canScrollLeft) {
      scrollContainer.scrollLeft -= scrollSpeed
    } else if (mouseX > containerRect.right - scrollThreshold && canScrollRight) {
      scrollContainer.scrollLeft += scrollSpeed
    }
  }

  let mouseX = 0

  function _addMouseListener () {
    const mouseMoveHandler = (e) => {
      mouseX = e.clientX
    }

    const mouseLeaveHandler = () => {
      if (isDragging) {
        isDragging = false
        _stopAutoScroll()
      }
    }

    const windowBlurHandler = () => {
      if (isDragging) {
        isDragging = false
        _stopAutoScroll()
      }
    }

    document.addEventListener('mousemove', mouseMoveHandler)
    document.addEventListener('mouseleave', mouseLeaveHandler)
    window.addEventListener('blur', windowBlurHandler)

    $scope.$on('$destroy', () => {
      document.removeEventListener('mousemove', mouseMoveHandler)
      document.removeEventListener('mouseleave', mouseLeaveHandler)
      window.removeEventListener('blur', windowBlurHandler)
      _stopAutoScroll()

      if (sortableInstance) {
        sortableInstance.destroy()
        sortableInstance = null
      }
    })
  }

  $scope.onSelectIndex = (index) => {
    $scope.selectedIndex = index.index
    $scope.$emit('imageCarousel:selectionChanged', {
      selectedIndex: $scope.selectedIndex
    })
  }

  $scope.openNewModal = function () {
    api.getAddMaterialsModalController().then(({ AddMaterialsModalController }) => {
      const existingMaterials = $scope.materials ? $scope.materials.map(material => ({
        id: material.id,
        name: material.name,
        thumbnailUrl: material.thumbnail || material.url,
        pagesCount: material.pageCount || 1,
        size: material.size,
        fileSize: material.fileSize
      })) : []

      const addMaterialsModal = UdsModalService.createModal({
        controller: AddMaterialsModalController,
        modalName: 'addMaterialsModal',
        data: {
          selectedTab: 'materials',
          existingMaterials: existingMaterials
        },
        onClose: materials => api._onMaterialsToAttach(materials)
      })

      addMaterialsModal.open()
    })
  }

  $scope.onAddMoreImages = () => {
    if (!$scope.isLimitReached() && !$scope.hasMultiPageMaterial) {
      $scope.openNewModal()
    }
  }

  $scope.isLimitReached = () => {
    return SocialMediaService.hasTooManyMaterials($scope.materials, true)
  }

  $scope.hasOversizedImages = () => {
    return SocialMediaService.hasOversizedMaterials($scope.materials)
  }

  $scope.getOversizedImages = () => {
    return SocialMediaService.getOversizedMaterials($scope.materials)
  }

  $scope.isImageOversized = (material) => {
    return SocialMediaService.isMaterialOversized(material)
  }

  $scope.getAddMoreImagesTooltip = () => {
    return $scope.hasMultiPageMaterial
      ? $translate.instant('imageCarousel.multiPageMaterialTooltip')
      : $translate.instant('addMaterialsModal.imageLimitReached')
  }

  $scope.handleImageError = (event) => {
    const imgElement = event.target
    const placeholderElement = imgElement.nextElementSibling

    if (imgElement && placeholderElement) {
      imgElement.style.display = 'none'
      placeholderElement.style.display = 'flex'
    }
  }

  function _handleMultiPageMaterial (newMaterials) {
    const materialArtId = newMaterials[0].artId || newMaterials[0].id
    const originalMaterial = newMaterials[0].originalMaterial || newMaterials[0]

    SocialMediaService.getContentToPublish('instagram', materialArtId).then(response => {
      const result = response.map(item => {
        return {
          id: item.layerId,
          artId: materialArtId,
          layerId: item.layerId,
          name: `layer - ${item.layerId}`,
          url: item.signedUrl,
          thumbnail: item.signedUrl,
          fileSize: newMaterials[0].fileSize,
          multiPage: true,
          originalMaterial: originalMaterial
        }
      })

      $scope.hasMultiPageMaterial = result.some(material => material.multiPage)
      $scope.materials = result
      if (result.length > 0) {
        $scope.selectedIndex = 0
      }

      $scope.$emit('imageCarousel:materialsUpdated', {
        materials: result,
        hasMultiPageMaterial: $scope.hasMultiPageMaterial
      })
    })
  }

  $scope.$watch('materials', (newMaterials) => {
    if (!newMaterials || !newMaterials.length) return

    const hasMultiPageMaterial = newMaterials.some(material => material.template?.layers?.length > 1)

    if (hasMultiPageMaterial) {
      api._handleMultiPageMaterial(newMaterials)
    }

    if (newMaterials) {
      const hasErrors = $scope.hasOversizedImages()
      $scope.$emit('imageCarousel:validationChanged', {
        hasErrors,
        canContinue: !hasErrors
      })
    }
  }, true)

  $scope.onRemoveImage = (params) => {
    const materialId = params.materialId
    const index = params.index

    let removeIndex = index
    if (materialId !== undefined) {
      removeIndex = $scope.materials?.findIndex(material => material.id === materialId)
    }

    try {
      if ($scope.materials && removeIndex >= 0 && removeIndex < $scope.materials.length) {
        if ($scope.materials.length === 1) {
          ToastService.showErrorToast($translate.instant('addMaterialsModal.toast.cannotRemoveLastImage'))
          return
        }

        const removedMaterial = $scope.materials[removeIndex]
        $scope.materials.splice(removeIndex, 1)

        if ($scope.selectedIndex === removeIndex) {
          if ($scope.materials.length > 0) {
            $scope.selectedIndex = Math.min(removeIndex, $scope.materials.length - 1)
          } else {
            $scope.selectedIndex = 0
          }
        } else if ($scope.selectedIndex > removeIndex) {
          $scope.selectedIndex--
        }

        $scope.$emit('imageCarousel:removeImage', {
          index: removeIndex,
          materialId,
          material: removedMaterial,
          materials: $scope.materials,
          selectedIndex: $scope.selectedIndex
        })

        $scope.$emit('imageCarousel:selectionChanged', {
          selectedIndex: $scope.selectedIndex
        })

        _reinitializeSortable()

        ToastService.showSuccessToast($translate.instant('addMaterialsModal.toast.materialRemoved'))
      }
    } catch (error) {
      ToastService.defaultErrorToast()
    }
  }

  function _onMaterialsToAttach (materials) {
    if (!materials?.length) {
      return
    }

    const images = materials.map(material => {
      const imageUrl = material.thumbnailUrl || material.previewUrl || material.url
      const pageCount = material.pagesCount || material.pageCount || 1

      return {
        id: material.id,
        artId: material.artId || material.id,
        name: material.name || material.title || 'Material',
        url: imageUrl,
        thumbnail: imageUrl,
        pageCount,
        isMultiPage: pageCount > 1,
        size: material.size,
        fileSize: material.fileSize,
        originalMaterial: material
      }
    })

    $scope.materials = images
    if (images.length > 0 && $scope.selectedIndex === null) {
      $scope.selectedIndex = 0
    }

    _reinitializeSortable()

    $scope.$emit('imageCarousel:addImages', images)
  }
}

export { ImageCarouselController }
